import React, { useEffect, useState } from 'react';
import '../../sass/components/_why-choose-us.scss';
import { Link } from 'react-router-dom';
import choose from '../../images/slider/kihi-banner.webp';

const WhyChooseUs = () => {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const features = [
    'One-Stop Solutions',
    'Quality Assurance',
    'Global Reach',
    'Innovative Solutions',
    'Customer-Centric Approach'
  ];

  

  return (
    <section className="why-choose-us">

      <div className="container">
        <div className="content-card">
          <div className="main-content">
            <h2 className="title">Why Choose Us</h2>
            <p className="description">
              We have a long history of manufacturing and exporting high-quality electrical and earthing 
              products, and we are dedicated to providing customized solutions as required by our clients.
            </p>

            <div className="features-list">
              {features.map((feature, index) => (
                <div key={index} className="feature-item">
                  <div className="arrow-icon">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path 
                        d="M2 8H14M14 8L8 2M14 8L8 14" 
                        stroke="currentColor" 
                        strokeWidth="2" 
                        strokeLinecap="round" 
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <span className="feature-text">{feature}</span>
                  <div className="feature-underline"></div>
                </div>
              ))}
            </div>
          </div>

          <div className="image-section">
            <img 
              src="https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=400&h=300&fit=crop" 
              alt="Why choose us illustration" 
              className="feature-image"
            />
          </div>
        </div>

      </div>
    </section>
  );
};

export default WhyChooseUs;